const preventDefault = (fn) => (event) => {
    event.preventDefault();
    if (fn)
        fn(event);
};
export default preventDefault;
//# sourceMappingURL=preventDefault.js.map